module.exports = __webpack_public_path__ + "img/octopus.c7e020d8.jpg";